import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { LinkComponent } from '../../LinkComponent';
import { TableItemToolbar, columnToolbar } from '../../SubComponents';
import { ShowStatus } from './ShowStatus';
import { IMonthlyOrdersListItem } from '../../../interfaces';
import { useMonthlyOrdersTable, useUiIsLoading, useUiSearch } from '../../../hooks';
import { dateText2Utc } from '../../../instruments';
import { tF, tI } from '../../../translate';
import { Catcher } from '../../Catcher';
import Styles from '../../styles/m_viewStyles.less';

export const MonthlyOrdersListTable: React.FC = observer(() => {
    const isLoading = useUiIsLoading();
    const list = useMonthlyOrdersTable();
    const search = useUiSearch();

    const tableColumns = [
        {
            title: tF('ID'),
            dataIndex: 'idLink',
        },
        {
            title: tF('Year Month'),
            dataIndex: 'yearMonth',
        },
        {
            title: tF('Company'),
            dataIndex: 'companyLink',
        },
        {
            title: tF('Invoicing Company'),
            dataIndex: 'invoicingCompanyLink',
        },
        {
            title: tF('Amount'),
            dataIndex: 'amount',
            className: Styles.columnRight,
        },
        {
            title: tF('linked orders count'),
            dataIndex: 'linkedOrdersCount',
            className: Styles.columnRight,
        },
        {
            title: tF('purchase order number'),
            dataIndex: 'purchaseOrderNumber',
            className: Styles.columnRight,
        },
        {
            title: tF('Start Date'),
            dataIndex: 'periodStart',
        },
        {
            title: tF('End Date'),
            dataIndex: 'periodEnd',
        },
        {
            title: tF('Status'),
            dataIndex: 'status',
        },
        {
            title: tF('Created at'),
            dataIndex: 'createdAt',
        },
        {
            title: tF('Updated at'),
            dataIndex: 'updatedAt',
        },
        columnToolbar,
    ];

    const tableData = list.map((order: IMonthlyOrdersListItem) => {
        return {
            key: order.id,
            ...order,
            yearMonth: `${order.year}-${order.month}`,
            idLink: <LinkComponent currentListComponent={'MonthlyOrdersList'} id={order.id.toString()} />,
            companyLink: (
                <LinkComponent
                    currentListComponent={'BillingCompaniesList'}
                    id={order?.companyId?.id}
                    isLight
                    name={order?.companyId?.name}
                />
            ),
            invoicingCompanyLink: (
                <LinkComponent
                    currentListComponent={'BillingCompaniesList'}
                    id={order?.invoicingCompany?.id}
                    isLight
                    name={order?.invoicingCompany?.name}
                />
            ),
            periodStart: dateText2Utc(order.periodStart),
            periodEnd: dateText2Utc(order.periodEnd),
            status: <ShowStatus status={order.status} search={search} />,
            createdAt: dateText2Utc(order.createdAt),
            updatedAt: dateText2Utc(order.updatedAt),
            toolbar: <TableItemToolbar id={order?.id.toString() || ''} itemName={`"${order.id}" ${tI('order')}`} />,
        };
    });

    return (
        <Catcher>
            <div className={Styles.tablePlace}>
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
